var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefit-info-block"},[_c('img',{staticClass:"image",attrs:{"src":_vm.benefit.icon,"alt":""}}),_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.benefit.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.benefit.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }